/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Field_Email_LabelInputs */

const en_contact_field_email_label = /** @type {(inputs: Contact_Field_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work email`)
};

/**
* | output |
* | --- |
* | "Work email" |
*
* @param {Contact_Field_Email_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_field_email_label = /** @type {((inputs?: Contact_Field_Email_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Field_Email_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_field_email_label(inputs)
});